import styled from "styled-components";
import { useState } from "react";
import Header from "./Header";
import SpecificCategory from "./SpecificCategory";

const Home2 = () => {
  const [activeCategory, setActiveCategory] = useState("all-posts");
  return (
    <Container>
      <Header setActiveCategory={setActiveCategory} />
      <Layout>
        <SpecificCategory activeCategory={activeCategory} setActiveCategory={setActiveCategory}/>
      </Layout>
    </Container>
  );
};

const Container = styled.div`
  padding-top: 52px;
  width: 100%;
`;

const Layout = styled.div`
  display: flex;
  justifycontent: "center";
  alignitems: "center";

  @media (max-width: 767px) {
    margin: 20px 0px 0px 0px;
  }
`;

export default Home2;
